(function(window, angular){'use strict';

var ngModule = angular.module('pp.services.investor-compliance', ['pp.services.core', 'pp.services.private-nationality']);

/**
 * @ngdoc service
 * @name investorComplianceService
 *
 * @description
 * Provides methods for investor complicance, primerily around KYC and investor identification services.
 */

ngModule.service('investorComplianceService', ['$http', '$q', 'privateNationalityService', function ($http, $q, privateNationalityService) {

    var promiseCache = {};

    var api = {};

    var helperService = privateNationalityService;

    var API_BASE_PATH = '/feapi/r1';

    // LEI endpoints
    var API_INVESTOR_IDENTIFIERS = API_BASE_PATH + '/investor/identifiers';
    var API_INVESTOR_IDENTIFIERS_TYPES = API_BASE_PATH + '/investor-identifiers/types?investorType=corporate';

    // -- util functions

    /**
     * @ngdoc method
     * @name investorComplianceService#getLeiType
     *
     * @description
     * When queried returns the users LEI type for corporate investors
     *
     */

    api.getLeiType = function () {

        var cacheKey = 'leiTypeCache';

        if (!promiseCache[cacheKey]) {
            promiseCache[cacheKey] = $http.get(API_INVESTOR_IDENTIFIERS_TYPES).then(function (response) {
                if (!response) {
                    return undefined;
                }
                if (response.data.collection) {
                    return response.data.collection[0];
                } else {
                    return undefined;
                }
            }, function (error) {

                delete promiseCache[cacheKey];

                switch (error.status) {
                case 404:
                    return null;
                default:
                    return $q.reject({
                        reason: 'lei-identifiers.error.unexpected'
                    });
                }
            });
        }

        return promiseCache[cacheKey];
    };

    // -- api

    /**
     * @ngdoc method
     * @name investorComplianceService#getLei
     *
     * @description
     * When queried returns the users LEI identifier
     *
     */

    api.getLei = function (leiType) {

        return $http.get(API_INVESTOR_IDENTIFIERS).then(function (response) {
            if (!response) {
                return undefined;
            }
            if (angular.isArray(response.data.collection)) {
                return response.data.collection.filter(function (item) {
                    return item.identifierTypeId === leiType.id;
                })[0] || null;
            } else {
                return undefined;
            }
        }, function (error) {
            switch (error.status) {
            case 404:
                return null;
            default:
                return $q.reject({
                    reason: 'investor-lei.error.unexpected'
                });
            }
        });

    };

    /**
     * @ngdoc method
     * @name investorComplianceService#postLei
     *
     * @description
     * Posts LEI identifier
     *
     *
     *  {
     *      identifierTypeId: 1,
     *      value: '123456'
     *  };
     *
     */

    api.postLei = function (typeId, lei) {

        var identifier = {
            id: typeId,
            identifierValue: lei
        };

        return helperService._postInvestorIdentifier(identifier).then(function () {
            return true;
        }, function (error) {
            switch (error.status) {
            default:
                return $q.reject({
                    reason: 'investor-lei.error.unexpected'
                });
            }
        });

    };

    /**
     * @ngdoc method
     * @name investorComplianceService#deleteLei
     *
     * @description
     * Posts LEI identifier
     *
     *
     *  @params
     *  typeId: Int
     *
     */

    api.deleteLei = function (typeId) {

        var endpoint = API_INVESTOR_IDENTIFIERS + '/' + typeId;

        return $http.delete(endpoint).then(function () {
            return true;
        }, function (error) {
            switch (error.status) {
            case 404:
                return;
            default:
                return $q.reject({
                    reason: 'investor-lei.error.unexpected'
                });
            }
        });

    };

    api.isLeiSet = function () {
        return api.getLeiType().then(function (type) {
                return api.getLei(type).then(function (lei) {
                    return !!lei;
                });
            })
            .catch(function () {
                return false;
            });
    };

    return api;

}]);
})(window, window.angular);